module.exports = __webpack_public_path__ + "img/changeAllocation-1.2a67d23.webp";